"use strict";
import { ComboboxMarkup } from "./";
export const Template = ComboboxMarkup;
//# sourceMappingURL=template.js.map
